import i18n from '@/plugins/i18n';
import {
  KAFKA_OVERVIEW_TAB_KEY,
  KAFKA_PRODUCER_TAB_KEY,
  KAFKA_CONSUMER_TAB_KEY,
  KAFKA_BROKER_TAB_KEY,
  NAVTAB_KAFKA_KEY,
} from '@/utils/templates/mqTemplate/mq.constants';

const kafkaOverviewComponents = () => [
  {
    key: KAFKA_OVERVIEW_TAB_KEY.BROKER,
    tabName: i18n.global.t('mq.broker'),
    isActive: true,
    type: 'broker',
  },
  {
    key: KAFKA_OVERVIEW_TAB_KEY.PRODUCER,
    tabName: i18n.global.t('mq.producer'),
    isActive: false,
    type: 'producer',
  },
  {
    key: KAFKA_OVERVIEW_TAB_KEY.CONSUMER,
    tabName: i18n.global.t('mq.consumer'),
    isActive: false,
    type: 'consumer',
  },
];

const kafkaProducerComponents = () => [
  {
    key: KAFKA_PRODUCER_TAB_KEY.BROKER,
    tabName: i18n.global.t('mq.broker'),
    isActive: true,
  },
  {
    key: KAFKA_PRODUCER_TAB_KEY.TOPIC,
    tabName: i18n.global.t('mq.topic'),
    isActive: false,
  },
];

const kafkaConsumerComponents = () => [
  {
    key: KAFKA_CONSUMER_TAB_KEY.PARTITION,
    tabName: i18n.global.t('mq.partitionMetrics'),
    isActive: true,
  },
  {
    key: KAFKA_CONSUMER_TAB_KEY.REQUEST,
    tabName: i18n.global.t('mq.requestMetrics'),
    isActive: false,
  },
  {
    key: KAFKA_CONSUMER_TAB_KEY.CONNECTION,
    tabName: i18n.global.t('mq.connectionMetrics'),
    isActive: false,
  },
];

const kafkaBrokerComponents = () => [
  {
    key: KAFKA_BROKER_TAB_KEY.TOPIC,
    tabName: i18n.global.t('mq.topic'),
    isActive: true,
  },
  {
    key: KAFKA_BROKER_TAB_KEY.JVM,
    tabName: i18n.global.t('mq.brokerMetrics'),
    isActive: false,
  },
];

const participantListHeader = () =>
  Object.freeze({
    [KAFKA_PRODUCER_TAB_KEY.BROKER]: i18n.global.t('mq.producer'),
    [KAFKA_PRODUCER_TAB_KEY.TOPIC]: i18n.global.t('mq.topic'),
    [KAFKA_BROKER_TAB_KEY.JVM]: i18n.global.t('mq.broker'),
    [KAFKA_BROKER_TAB_KEY.TOPIC]: i18n.global.t('mq.topic'),
  });

const participantListSearchMsg = () =>
  Object.freeze({
    [KAFKA_PRODUCER_TAB_KEY.BROKER]: i18n.global.t('mq.searchProducer'),
    [KAFKA_PRODUCER_TAB_KEY.TOPIC]: i18n.global.t('mq.searchTopic'),
    [KAFKA_BROKER_TAB_KEY.JVM]: i18n.global.t('mq.searchBroker'),
    [KAFKA_BROKER_TAB_KEY.TOPIC]: i18n.global.t('mq.searchTopic'),
  });

const participantSelectMsg = Object.freeze({
  [KAFKA_PRODUCER_TAB_KEY.BROKER]: i18n.global.t('mq.producer'),
  [KAFKA_PRODUCER_TAB_KEY.TOPIC]: i18n.global.t('mq.topic'),
  [KAFKA_BROKER_TAB_KEY.TOPIC]: i18n.global.t('mq.topic'),
  [KAFKA_BROKER_TAB_KEY.JVM]: i18n.global.t('mq.broker'),
});

const maxSelectedInstance = 4;

function updateSelectedKeys(list, newParticipants) {
  const selectedList = list?.filter((obj) => obj.selected) ?? [];
  const selectedListKeys = selectedList?.map((obj) => obj.key) ?? [];

  return newParticipants.map((participant, index) => {
    return {
      key: participant.key,
      label: participant.label,
      consumerGroups: participant.consumerGroups || [],
      selected:
        (selectedListKeys.length === 0 && index === 0) ||
        selectedListKeys.includes(participant.key),
    };
  });
}
const instanceTypeMapping = Object.freeze({
  [KAFKA_OVERVIEW_TAB_KEY.BROKER]: 'broker',
  [KAFKA_OVERVIEW_TAB_KEY.PRODUCER]: 'producer',
  [KAFKA_OVERVIEW_TAB_KEY.CONSUMER]: 'consumer',
  [KAFKA_BROKER_TAB_KEY.JVM]: 'broker',
  [KAFKA_BROKER_TAB_KEY.TOPIC]: 'topic',
  [KAFKA_PRODUCER_TAB_KEY.BROKER]: 'producer',
  [KAFKA_PRODUCER_TAB_KEY.TOPIC]: 'topic',
});

const kafkaComponentMapping = Object.freeze({
  [NAVTAB_KAFKA_KEY.OVERVIEW]: 'KafkaOverview',
  [NAVTAB_KAFKA_KEY.PRODUCER]: 'KafkaProducer',
  [NAVTAB_KAFKA_KEY.CONSUMER]: 'KafkaConsumer',
  [NAVTAB_KAFKA_KEY.BROKER]: 'KafkaBroker',
  [NAVTAB_KAFKA_KEY.ZOOKEEPER]: 'KafkaZookeeper',
});

export {
  kafkaOverviewComponents,
  kafkaProducerComponents,
  kafkaConsumerComponents,
  kafkaBrokerComponents,
  participantListHeader,
  participantListSearchMsg,
  participantSelectMsg,
  maxSelectedInstance,
  updateSelectedKeys,
  instanceTypeMapping,
  kafkaComponentMapping,
};
